import { TDispatch } from 'state';
import { forgetPassword as forgotPasswordApi } from '../../api';
import ErrorNotifier from 'app/scripts/services/error-notifier';
import { forgotPasswordStart, forgotPasswordSuccess, forgotPasswordFailure } from './index';
import { Error } from 'utils/global';
import me from '@spotim/fed-resources/resources/me';

type Payload = {
  url: string;
  email: string;
  networkId: string;
  spotId: string;
};

const forgotPassword = ({ url, email, networkId, spotId }: Payload) => {
  return async (dispatch: TDispatch) => {
    dispatch(forgotPasswordStart());
    try {
      let { body } = await me.fetchNetworkToken(networkId);
      let mockSpotId = body.network_spots_ids[0];
      await forgotPasswordApi(email, url, networkId, mockSpotId);
      dispatch(forgotPasswordSuccess());
    } catch (error) {
      dispatch(forgotPasswordFailure());
      ErrorNotifier.notifyError(new Error(`Failed on forgot password with email - ${email}`));
    }
  };
};

export default forgotPassword;
